import { Injectable } from '@angular/core';
import { FileType } from '@fi-shared/types';
import { AppTextService } from '@fi-shared/app-text';
import { isDefined } from '@fi-shared/utils';

@Injectable()
export class FiFileUploadHelperService {
    constructor(private appTextService: AppTextService) {}

    getInsertFileErrorContentText(fileTypes: FileType[]): string {
        if (!isDefined(fileTypes)) {
            return undefined;
        }

        if (fileTypes?.length === 1) {
            if (fileTypes.includes(FileType.Excel)) {
                return this.appTextService.get('media.only_excel_can_be_uploaded');
            }
            if (fileTypes.includes(FileType.Image)) {
                return this.appTextService.get('media.only_images_can_be_uploaded');
            }
        }
        if (fileTypes?.length === 2) {
            if (fileTypes.includes(FileType.Image) && fileTypes.includes(FileType.Movie)) {
                return this.appTextService.get('ccmFileUpload.only_videos_images');
            }
        }

        return this.appTextService.get('error_message.default_header');
    }
}
